'use client';

import { useTranslations } from 'next-intl';

import { Link } from '@/components/Link';
import ChevronIcon from '@/components/icons/ChevronIcon';
import TertiaryHeading from '@/components/typography/TertiaryHeading';
import { SimpleLocationDto } from '@/lib/locations/dto';
import { tiemposFont } from '@/theme/tiemposFont';
import { MAP_SEARCH_MARKET_NEARBY_ZOOM } from '@/utils/constants';

import NearbyLocationItem from './NearbyLocationItem';

import clsx from 'clsx';

type NearbyLocationsListProps = {
  nearLocations: SimpleLocationDto[];
  market: string;
};

export default function NearbyLocationsList({
  nearLocations,
  market,
}: NearbyLocationsListProps) {
  const t = useTranslations('location.nearby-locations');

  if (nearLocations.length === 0) {
    return null;
  }

  const { geolocalization: firstLocationCoords } = nearLocations[0];
  const marketUrl = `/locations?query=${market}&center=${[
    firstLocationCoords.lng,
    firstLocationCoords.lat,
  ]}&zoom=${MAP_SEARCH_MARKET_NEARBY_ZOOM}`;

  return (
    <section>
      <TertiaryHeading className="mb-5">{t('title')}</TertiaryHeading>

      <ul className="flex flex-col gap-5">
        {nearLocations.map((location) => (
          <li key={location.slug}>
            <NearbyLocationItem location={location} />
          </li>
        ))}
      </ul>

      <Link
        className={clsx(
          tiemposFont.className,
          'flex items-center mt-5 mb-4 text-xl text-teal-40 font-medium'
        )}
        href={marketUrl}
      >
        {t('link-all-locations', { market })}
        <ChevronIcon
          className="ml-2 rotate-[-90deg] stroke-ocean-60"
          isBold
          aria-hidden="true"
        />
      </Link>
    </section>
  );
}
